import { ApiResponseContent } from '../models/custom-models';
import ApiBase from './base/ApiBase'
import { InvitationItem } from './ManageOrganizationClient';

class AccountClient extends ApiBase
{
    private controllerName: string = 'Account';

    async CreateOrganization(context: CreateOrganizationContext, signal?: AbortSignal) : Promise<ApiResponseContent<string>>
    {
        return this.PostAsync(`${this.controllerName}/Create/Organization`, context, signal);
    }

    async CreateAccount(invitationId: string, context: CreateAccountContext, signal?: AbortSignal) : Promise<ApiResponseContent<string>>
    {
        return this.PostAsync(`${this.controllerName}/Create/${invitationId}`, context, signal);
    }

    async GetInvitation(invitationId: string, signal?: AbortSignal) : Promise<InvitationItem>
    {
        return this.GetAsync(`${this.controllerName}/Invitation/${invitationId}`, signal);
    }

    async AcceptInvitation(invitationId: string, signal?: AbortSignal) : Promise<void>
    {
        return this.PutAsync(`${this.controllerName}/Invitation/${invitationId}/Accept`, null, signal, null);
    }

    async RejectInvitation(invitationId: string, signal?: AbortSignal) : Promise<void>
    {
        return this.PutAsync(`${this.controllerName}/Invitation/${invitationId}/Reject`, null, signal, null);
    }
}

export interface CreateOrganizationContext extends CreateAccountContext
{
    OrganizationName: string;
    Positions: string[];
}

export interface CreateAccountContext
{
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    RoleTemplate?: string;
}

export default AccountClient;